import CancelIcon from "@mui/icons-material/Cancel";
import { IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { IconButton } from "../../components";

export const CancelIconButton = (
  props: MuiIconButtonProps & {
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  }
) => {
  const { onClick, ...rest } = props;
  
  return (
    <IconButton onClick={onClick} {...rest} size="small">
      <CancelIcon />
    </IconButton>
  );
};
